import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:8001";

export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("surit_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  try { config.vigenciaClinicId = JSON.parse(localStorage.getItem("surit_user"))?.active_clinic_id; } catch { /* sin sesión guardada */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403 && err.response.data?.code === "PLAN_NO_VIGENTE") {
      window.dispatchEvent(new CustomEvent("surit:plan-no-vigente", { detail: {
        motivo: err.response.data.motivo, clinicId: err.config?.vigenciaClinicId,
      } }));
    }
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/app")) {
        localStorage.removeItem("surit_token");
        localStorage.removeItem("surit_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (detail) => {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

export const formatMXN = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(n || 0);
